module.exports = __webpack_public_path__ + "static/media/history_7.326edc02.jpg";